import Immutable from 'seamless-immutable';
import {
    SUBMISSION_CREATE_REQUEST,
    SUBMISSION_CREATE_SUCCESS,
    SUBMISSION_CREATE_ERROR,
    SUBMISSION_DATA_REQUEST,
    SUBMISSION_DATA_SUCCESS,
    SUBMISSION_DATA_ERROR,
    SUBMISSION_ADD_COMMENT_REQUEST,
    SUBMISSION_ADD_COMMENT_SUCCESS,
    SUBMISSION_ADD_COMMENT_ERROR,
    SUBMISSION_COMMENTS_REQUEST,
    SUBMISSION_COMMENTS_SUCCESS,
    SUBMISSION_COMMENTS_ERROR,
    SUBMISSION_CHANGE_REQUEST,
    SUBMISSION_CHANGE_SUCCESS,
    SUBMISSION_CHANGE_ERROR,
    SUBMISSION_ASSIGN_REVIEWERS_ERROR,
    SUBMISSION_ASSIGN_REVIEWERS_REQUEST,
    SUBMISSION_ASSIGN_REVIEWERS_SUCCESS,
} from 'Actions/submission';
import { READ_EMAIL_SUCCESS } from 'Actions/email';

export const INITIAL_STATE = Immutable({
    loading: false,
    success: false,
    error: false,
    submission: {},
    comments: [],
    filter: {
        include: ['user'],
        order: 'submission_comments.id desc'
    }
});

export default function submissionDataReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SUBMISSION_CREATE_REQUEST:
        case SUBMISSION_CHANGE_REQUEST:
        case SUBMISSION_COMMENTS_REQUEST:
        case SUBMISSION_DATA_REQUEST:
        case SUBMISSION_ADD_COMMENT_REQUEST:
        case SUBMISSION_ASSIGN_REVIEWERS_REQUEST:
            return state.merge({
                loading: true,
                success: false,
                error: false,
            });

        case SUBMISSION_CREATE_ERROR:
        case SUBMISSION_CHANGE_ERROR:
        case SUBMISSION_COMMENTS_ERROR:
        case SUBMISSION_DATA_ERROR:
        case SUBMISSION_ADD_COMMENT_ERROR:
        case SUBMISSION_ASSIGN_REVIEWERS_ERROR:
            return state.merge({
                loading: false,
                success: false,
                error: true,
            });

        case SUBMISSION_CREATE_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
            });

        case SUBMISSION_ADD_COMMENT_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
                comments: [action.payload.data, ...state.comments],
            });

        case SUBMISSION_DATA_SUCCESS:
        case SUBMISSION_CHANGE_SUCCESS:
        case SUBMISSION_ASSIGN_REVIEWERS_SUCCESS:
        case READ_EMAIL_SUCCESS:
            return state.merge({
                loading: false,
                success: true,
                error: false,
                submission: action.payload.data,
            });

        case SUBMISSION_COMMENTS_SUCCESS: {
            return state.merge({
                loading: false,
                success: true,
                error: false,
                comments: action.payload.data,
            });
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/submissionDataReducer.js